import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { InfoIcon } from 'reaxl';
import { Checkbox } from 'reaxl-forms';
import WalletSnapshot from '../WalletSnapshot';
function WalletOptIn(_ref) {
  let {
    contents = [],
    updateMyWallet = () => {}
  } = _ref;
  const ref = useRef();
  const containerRef = useRef();
  const handleOverlayTrigger = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  const handleEditClick = e => {
    e.preventDefault();
    ref.current.setShowOverlay(false);
    updateMyWallet({
      displayModal: true
    });
  };
  const label = /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "text-size-200 display-inline-block"
  }, "Include My Wallet Information\xA0", /*#__PURE__*/React.createElement(InfoIcon, {
    onClick: handleOverlayTrigger,
    placement: "top",
    popoverId: "paymentInfo",
    ref: ref,
    container: containerRef.current,
    trigger: ['click'],
    infoText: /*#__PURE__*/_jsx(WalletSnapshot, {
      action: {
        label: 'Edit',
        onClick: handleEditClick
      },
      contents: contents,
      title: "My Wallet",
      tableClassName: "margin-bottom-0"
    })
  }));
  return /*#__PURE__*/_jsx(Checkbox, {
    name: "includeWalletData",
    labelClassName: "margin-bottom-4",
    label: label,
    value: true
  });
}
export default WalletOptIn;